import { useIntl } from "react-intl";

const ServiceRegistry = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceRegistry.header",
            defaultMessage: "Service Registry"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceRegistry.body",
            defaultMessage:
                "IT teams can register all the services they operate, providing additional context for any changes. Link issues to affected services, and streamline incidents when they occur."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ServiceRegistry;
